<script lang="ts" setup>
import UserMenuDesktop from './UserMenuDesktop.vue'
import UserMenuMobile from './UserMenuMobile.vue'
</script>

<template>
  <div class="flex items-center h-full">
    <UserMenuDesktop class="hidden lg:flex"/>
    <UserMenuMobile class="lg:hidden"/>
  </div>
</template>
